//import layouts
import AuthLayout from "src/pages/Layouts/AuthLayout.vue";
import GuestLayout from "src/pages/Layouts/GuestLayout.vue";
//import middleware
import auth from "@/middleware/auth";
import guest from "@/middleware/guest";
// Errors
import NotFound from "src/pages/Errors/NotFoundPage.vue";

// Dashboard pages
const Dashboard = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/GeneralViews/Dashboard/Dashboard.vue"
  );
const Header = () =>
  import(/* webpackChunkName: "dashboard" */ "src/components/Header.vue");

const Login = () =>
  import(/* webpackChunkName: "auth" */ "src/pages/Login.vue");

const Register = () =>
  import(/* webpackChunkName: "auth" */ "src/pages/Register.vue");

const Budgets = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Budgets/index.vue"
  );

const BudgetsDetails = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Budgets/details.vue"
  );

const Dimension = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Dimension/index.vue"
  );

const StringSizer = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/StringSizer/index.vue"
  );

const GenerateArrangements = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/StringSizer/GenerateArrangement.vue"
  );

const Orders = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Orders/index.vue"
  );

const OrderDetails = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Orders/details.vue"
  );

const Products = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Products/index.vue"
  );

const Brands = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Brands/index.vue"
  );

const BrandsCreate = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Brands/create.vue"
  );

const BrandsEdit = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Brands/edit.vue"
  );

const ProductsCategories = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/ProductsCategories/index.vue"
  );

const Roles = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Roles/index.vue"
  );

const RolesCreate = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Roles/create.vue"
  );

const RolesEdit = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Roles/edit.vue"
  );

const Permissions = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Permissions/index.vue"
  );

const PermissionsCreate = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Permissions/create.vue"
  );

const PermissionsEdit = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Permissions/edit.vue"
  );

const ModulesCreate = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Products/Modules/create.vue"
  );

const ModulesEdit = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Products/Modules/edit.vue"
  );

const InvertersCreate = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Products/Inverters/create.vue"
  );

const InvertersEdit = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Products/Inverters/edit.vue"
  );

const StructuresCreate = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Products/Structures/create.vue"
  );

const StructuresEdit = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Products/Structures/edit.vue"
  );

const StructuresTypesCreate = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Products/StructuresTypes/create.vue"
  );

const StructuresTypesEdit = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Products/StructuresTypes/edit.vue"
  );

const StringBoxesCreate = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Products/Others/StringBoxes/create.vue"
  );

const StringBoxesEdit = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Products/Others/StringBoxes/edit.vue"
  );

const ConnectorsCreate = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Products/Others/Connectors/create.vue"
  );

const ConnectorsEdit = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Products/Others/Connectors/edit.vue"
  );

const CablesCreate = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Products/Others/Cables/create.vue"
  );

const CablesEdit = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Products/Others/Cables/edit.vue"
  );

const TransformersCreate = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Products/Others/Transformers/create.vue"
  );

const TransformersEdit = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Products/Others/Transformers/edit.vue"
  );

const Shippings = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Shipping/index.vue"
  );

const ShippingsCreate = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Shipping/create.vue"
  );

const ShippingsEdit = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Shipping/edit.vue"
  );

const Users = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Users/index.vue"
  );

const UsersCreate = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Users/create.vue"
  );

const UsersEdit = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Users/edit.vue"
  );

const Customers = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Customers/index.vue"
  );

const CustomersEdit = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Customers/edit.vue"
  );

const Providers = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Providers/index.vue"
  );

const ProvidersCreate = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Providers/create.vue"
  );

const ProvidersEdit = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Providers/edit.vue"
  );

const Banner = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Banner/index.vue"
  );

const BannerCreate = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Banner/create.vue"
  );

const BannerEdit = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Banner/edit.vue"
  );

const ForgotPassword = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/ForgotPassword/index.vue"
  );

const ResetPassword = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/ForgotPassword/reset.vue"
  );

const RegisterClient = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Customers/create.vue"
  );

const MessageBoard = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/MessageBoard/index.vue"
  );

const MessageBoardEdit = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/MessageBoard/edit.vue"
  );

const Metrics = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/GeneralViews/Metrics/index.vue"
  );

let guestPages = {
  path: "/",
  component: GuestLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { middleware: guest },
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: { middleware: guest },
    },
    {
      path: "/forgot-password",
      name: "Forgot Password",
      component: ForgotPassword,
      meta: { middleware: guest },
    },
    {
      path: "/password/reset",
      name: "Reset Password",
      component: ResetPassword,
      meta: { middleware: guest },
    },
  ],
};

let budgets = [
  {
    path: "dimension",
    name: "Dimensionar",
    components: { default: Dimension, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "budgets",
    name: "Orçamentos",
    components: { default: Budgets, header: Header },
    meta: { middleware: auth, params: {permission: "view budgets"} },
  },
  {
    path: "budgets/details/:id",
    name: "Detalhes de Orçamento",
    components: { default: BudgetsDetails, header: Header },
    meta: { middleware: auth },
  },
];

let orders = [
  {
    path: "orders",
    name: "Pedidos",
    components: { default: Orders, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "orders/details/:id",
    name: "Detalhes de Pedido",
    components: { default: OrderDetails, header: Header },
    meta: { middleware: auth },
  },
];

let stringSizer = [
  {
    path: "string-sizer",
    name: "Dimensionador",
    components: { default: StringSizer, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "generate-arrangements",
    name: "Gerar arranjos",
    components: { default: GenerateArrangements, header: Header },
    meta: { middleware: auth },
  },
];

let products = [
  {
    path: "/settings/products",
    name: "Produtos",
    components: { default: Products, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/products/module/create",
    name: "Criar Módulo",
    components: { default: ModulesCreate, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/products/module/edit/:id",
    name: "Editar Módulo",
    components: { default: ModulesEdit, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/products/inverter/create",
    name: "Criar Inversor",
    components: { default: InvertersCreate, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/products/inverter/edit/:id",
    name: "Editar Inversor",
    components: { default: InvertersEdit, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/products/structure/create",
    name: "Criar Estrutura",
    components: { default: StructuresCreate, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/products/structure/edit/:id",
    name: "Editar Estrutura",
    components: { default: StructuresEdit, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/products/structure-type/create",
    name: "Criar Tipo de Estrutura",
    components: { default: StructuresTypesCreate, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/products/structure-type/edit/:id",
    name: "Editar Tipo de Estrutura",
    components: { default: StructuresTypesEdit, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/products/string-box/create",
    name: "Criar StringBox",
    components: { default: StringBoxesCreate, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/products/string-box/edit/:id",
    name: "Editar StringBox",
    components: { default: StringBoxesEdit, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/products/cable/create",
    name: "Criar Cabo",
    components: { default: CablesCreate, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/products/cable/edit/:id",
    name: "Editar Cabo",
    components: { default: CablesEdit, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/products/connector/create",
    name: "Criar Conector",
    components: { default: ConnectorsCreate, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/products/connector/edit/:id",
    name: "Editar Conector",
    components: { default: ConnectorsEdit, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/products/transformer/create",
    name: "Criar Transformador",
    components: { default: TransformersCreate, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/products/transformer/edit/:id",
    name: "Editar Transformador",
    components: { default: TransformersEdit, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/product-categories",
    name: "Categoria de Produtos",
    components: { default: ProductsCategories, header: Header },
    meta: { middleware: auth },
  },
];

let brands = [
  {
    path: "/settings/brands",
    name: "Marcas",
    components: { default: Brands, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/brands/create",
    name: "Criar Marca",
    components: { default: BrandsCreate, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/brands/edit/:id",
    name: "Editar Marca",
    components: { default: BrandsEdit, header: Header },
    meta: { middleware: auth },
  },
];

let permissions = [
  {
    path: "/settings/roles",
    name: "Cargos",
    components: { default: Roles, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/roles/create",
    name: "Criar Cargos",
    components: { default: RolesCreate, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/roles/edit/:id",
    name: "Editar Cargos",
    components: { default: RolesEdit, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/permissions",
    name: "Permissions",
    components: { default: Permissions, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/permissions/create",
    name: "Criar Permissions",
    components: { default: PermissionsCreate, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/permissions/edit/:id",
    name: "Editar Permissions",
    components: { default: PermissionsEdit, header: Header },
    meta: { middleware: auth },
  },
];

let shippings = [
  {
    path: "/shipping",
    name: "Frete",
    components: { default: Shippings, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/shipping/create",
    name: "Criar Frete",
    components: { default: ShippingsCreate, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/shipping/edit/:id",
    name: "Editar Frete",
    components: { default: ShippingsEdit, header: Header },
    meta: { middleware: auth },
  },
];

let users = [
  {
    path: "/settings/users",
    name: "Usuários",
    components: { default: Users, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/users/create",
    name: "Criar Usuário",
    components: { default: UsersCreate, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/users/edit/:id",
    name: "Editar Usuário",
    components: { default: UsersEdit, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/customers",
    name: "Clientes",
    components: { default: Customers, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/customers/edit/:id",
    name: "Editar Cliente",
    components: { default: CustomersEdit, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/register-client",
    name: "Cadastrar Cliente",
    components: { default: RegisterClient, header: Header },
    meta: { middleware: auth },
  }
];

let providers = [
  {
    path: "/settings/providers",
    name: "Fornecedores",
    components: { default: Providers, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/providers/create",
    name: "Criar Fornecedor",
    components: { default: ProvidersCreate, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/providers/edit/:id",
    name: "Editar Fornecedor",
    components: { default: ProvidersEdit, header: Header },
    meta: { middleware: auth },
  },
];

let banner = [
  {
    path: "/settings/banner",
    name: "Banner",
    components: { default: Banner, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/banner/create",
    name: "Criar Banner",
    components: { default: BannerCreate, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/banner/edit/:id",
    name: "Editar Banner",
    components: { default: BannerEdit, header: Header },
    meta: { middleware: auth },
  },
];

let messageBoard = [
  {
    path: "/settings/message-board",
    name: "Quadro de Mensagens",
    components: { default: MessageBoard, header: Header },
    meta: { middleware: auth },
  },
  {
    path: "/settings/message-board/edit/:id",
    name: "Editar Quadro de Mensagens",
    components: { default: MessageBoardEdit, header: Header },
    meta: { middleware: auth },
  },
];

let metrics = [
  {
    path: "/metrics",
    name: "Métricas",
    components: { default: Metrics, header: Header },
    meta: { middleware: auth },
  }
];

let authPages = {
  path: "/",
  component: AuthLayout,
  redirect: "/dashboard",
  name: "Home",
  children: [
    {
      path: "dashboard",
      name: "Dashboard",
      components: { default: Dashboard, header: Header },
      meta: { middleware: auth },
    },
    ...budgets,
    ...orders,
    ...stringSizer,
    ...products,
    ...brands,
    ...permissions,
    ...shippings,
    ...users,
    ...providers,
    ...banner,
    ...messageBoard,
    ...metrics
  ],
};

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    name: "Home",
  },
  guestPages,
  authPages,
  {
    path: "*",
    redirect: "/not-found",
    component: AuthLayout,
    children: [
      {
        path: "/not-found",
        name: "Página não encontrada",
        components: { default: NotFound, header: Header },
      },
    ],
  },
];

export default routes;
